import React, { useContext } from "react";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import {
  IAdvanceSearchFilter,
  IGroupInfoMembers,
  ISuggestedClinicianDepartmentId,
} from "@home-health-notify/domain";
import {
  AddMembersContext,
  DISTANCE_IN_MILES,
  IAddMembersContext,
  IOrganizationContext,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import { AdvanceSearchButton } from "../../../common/SearchBox.style";
import {
  RestAdvanceSearchDialogProps,
  useAdvanceSearchDialog,
} from "../../../context/AdvanceSearchDialogContext";
import { useSnackbar } from "notistack";
import { IPatientHeaderProps } from "./AdvanceSearchHelper";
import { isAddressEmpty } from "./map/AdvanceMapHelper";

type AdvanceSearchProps = {
  advanceSearchFilters?: IAdvanceSearchFilter;
  existingMembers?: IGroupInfoMembers[];
  fullWidth?: boolean;
  existingGroup?: boolean;
  resetAddedMembersOnClose?: boolean;
  patientHeaderProps?: IPatientHeaderProps;
  suggestedCliniciansDepartments?: ISuggestedClinicianDepartmentId[];
  searchRadius?: DISTANCE_IN_MILES;
  onAddMemberCallback: (selectedMembers: any) => void;
  openedFrom: string;
};

const AdvanceSearch = ({
  advanceSearchFilters,
  existingMembers,
  fullWidth = true,
  existingGroup,
  resetAddedMembersOnClose,
  patientHeaderProps,
  searchRadius,
  suggestedCliniciansDepartments = [],
  onAddMemberCallback,
  openedFrom,
}: AdvanceSearchProps) => {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);
  const { resetMembers }: IAddMembersContext = useContext(AddMembersContext);
  const { enqueueSnackbar } = useSnackbar();

  const { openDialog } = useAdvanceSearchDialog();
  const closeAdvanceSearchModal = () => {
    selectedOrgUser?.chatManager
      .getPatientChatManager()
      .resetAdvanceSearchClinicianList();
    resetAddedMembersOnClose && resetMembers();
  };

  const openAdvanceSearchModal = () => {
    if (isAddressEmpty(advanceSearchFilters)) {
      enqueueSnackbar(tNAdvanceSearch("updatePatientAddressMessage"), {
        autoHideDuration: 3000,
      });
    } else {
      openDialog(
        {
          advanceSearchFilters,
          existingMembers,
          existingGroup,
          patientHeaderProps,
          suggestedCliniciansDepartments,
          searchRadius,
          // Pass any other props needed by AdvanceSearchDialog
          closeModal: closeAdvanceSearchModal,
          onAddMemberCallback,
        } as RestAdvanceSearchDialogProps,
        openedFrom,
      );
    }
  };

  return (
    advanceSearchFilters && (
      <AdvanceSearchButton
        disableRipple
        disableTouchRipple
        fullWidth={fullWidth}
        variant="outlined"
        onClick={openAdvanceSearchModal}
        data-testid="advance-search-button"
      >
        <PersonPinCircleIcon />
        {tNAdvanceSearch("advanceSearch")}
      </AdvanceSearchButton>
    )
  );
};

export default AdvanceSearch;
